/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Moneyinput_Abbreviationstooltip2Inputs */

const en_moneyinput_abbreviationstooltip2 = /** @type {(inputs: Moneyinput_Abbreviationstooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supports shorthands: 1k = 1,000; 1m = 1,000,000; 1b = 1,000,000,000; 1t = 1,000,000,000,000`)
};

/**
* | output |
* | --- |
* | "Supports shorthands: 1k = 1,000; 1m = 1,000,000; 1b = 1,000,000,000; 1t = 1,000,000,000,000" |
*
* @param {Moneyinput_Abbreviationstooltip2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const moneyinput_abbreviationstooltip2 = /** @type {((inputs?: Moneyinput_Abbreviationstooltip2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Moneyinput_Abbreviationstooltip2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_moneyinput_abbreviationstooltip2(inputs)
});
export { moneyinput_abbreviationstooltip2 as "moneyInput_abbreviationsTooltip" }